import React from "react";
import "./footer.css";
import paymentImg from "../../assets/payment-img.png";

const Footer = () => {
  return (
    <section className="footer">
      <footer className="text-center">
        <div className="container p-4">
          <div className="row">
            <div className="col-lg-4 col-md-12 footer-col">
              <h5 className="footer-brand">LOCATION</h5>
              <p className="footer-par1 footer-par">
                1101 INDIANA ST LOS ANGELES USA
              </p>
            </div>
            <div className="col-lg-4 col-md-12 footer-col">
              <h5 className="footer-brand">SOCIAL MEDIA</h5>
              <div className="social-media-icons">
                <i className="fas fa-brands fa-facebook" />
                <i className="fas fa-brands fa-twitter" />
                <i className="fas fa-brands fa-instagram" />
              </div>
            </div>
            <div className="col-lg-4 col-md-12 footer-col">
              <h5 className="footer-brand">ABOUT</h5>
              <p className="footer-par">
                This website was created by
                <a
                  className="footer-link ms-1"
                  href="https://linkedin.com/in/emre-soylu/"
                  target="_blank"
                >
                  Emre Soylu
                </a>
              </p>
            </div>
          </div>
        </div>
        {/* Copyright */}
        <div
          className="text-center p-4"
          style={{ backgroundColor: "rgb(248, 203, 185)" }}
        >
          <img width="150px" src={paymentImg} alt="..." />
          <br />
          <br />
          <p className="copy-par my-auto">
            Copyright © Online<i className="logo-icon fa-brands fa-shopify"></i>
            <span className="me-1">hop</span>
            {new Date().getFullYear()}
          </p>
        </div>
      </footer>
    </section>
    // d-flex align-items-center justify-content-evenly
  );
};

export default Footer;
